module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('hr', {
    staticClass: "uk-wdith uk-divider-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-overflow-auto table-holder"
  }, [_c('table', {
    staticClass: "uk-table uk-table-middle uk-table-divider uk-margin-remove-top uk-table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "85px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('data')
      }
    }
  }, [_vm._v("Data\n                "), (_vm.orderKey == 'data') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Godzina\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('status')
      }
    }
  }, [_vm._v("Status\n                "), (_vm.orderKey == 'status') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('doctor')
      }
    }
  }, [_vm._v("Lekarz\n                "), (_vm.orderKey == 'doctor') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('reason')
      }
    }
  }, [_vm._v("Powód wizyty\n                "), (_vm.orderKey == 'reason') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    staticStyle: {
      "width": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('position')
      }
    }
  }, [_vm._v("\n                  Numer w kolejce\n                  "), (_vm.orderKey == 'position') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Dostępne działania\n\n              ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visits), function(visit) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDate")(visit.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(visit.data)))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [(visit.status === 'zarejestrowana') ? _c('span', {
      staticClass: "uk-label uk-label-primary"
    }, [_vm._v(_vm._s(visit.status))]) : _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v(_vm._s(visit.status))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [_vm._v(_vm._s(visit.doctor) + " " + _vm._s(visit.specjalizacja))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [_vm._v(_vm._s(visit.reason))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m",
      staticStyle: {
        "text-align": "center"
      }
    }, [(visit.position === '-1') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(visit.position))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-button-group"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'visit',
          params: {
            visitId: visit.idrejestracja,
            status: visit.status,
            ankieta: visit.ankieta,
            reason: visit.reason,
            doctor: visit.doctor,
            data: visit.data,
            position: visit.position,
            adres1: visit.adres1,
            adres2: visit.adres2,
            information: visit.info,
            type: visit.type,
            cena: visit.cena
          }
        }
      }
    }, [(visit.idrejestracja) ? _c('button', {
      staticClass: "see-more-btn uk-button uk-button-primary",
      attrs: {
        "type": "button",
        "title": "Otwórz pełen widok wizyty",
        "uk-tooltip": "pos: bottom"
      }
    }, [_vm._v("\n                    Zobacz\n                  ")]) : _vm._e()])], 1)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "uk-padding-remove"
  }, [_vm._v("Moje wizyty "), _c('div', {
    attrs: {
      "id": "visitLoader",
      "uk-spinner": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8657372","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Main.vue
// module id = 247
// module chunks = 1